<template>
  <div class="a-page-title">
    <Icon
      v-if="iconName"
      ref="page-title-icon"
      :name="iconName"
      class="a-page-title__icon"
    />
    <h1 ref="page-title" class="a-page-title__heading">
      {{ pageTitle }}
    </h1>
  </div>
</template>

<script>
import { Icon } from "@thegetty-private/getty-ui";

export default {
  name: "PageTitle",
  components: {
    Icon
  },
  props: {
    /**
     * Specifies if an icon should be placed before the page title and which one
     */
    iconName: {
      required: false,
      type: String,
      default: undefined
    },
    /**
     * The page title string to display
     */
    pageTitle: {
      required: true,
      type: String
    }
  }
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
